import {style} from 'typestyle'
import * as csstips from 'csstips'

const RIGHTDISTANCE = 160
const COVERHEIGHT = 90

export const HomeItemListItem = style({
    ...csstips.flexRoot,
    paddingTop: 15,
    paddingBottom: 15,
    position: 'relative',
    textDecoration: 'none',
    paddingLeft: 15,
    paddingRight: 15,
    $nest: {
        '&:last-child': {
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8
        },
        '&:active': {
            backgroundColor: '#f8f8f8'
        },
        '&::after': {
            content: `" "`,
            position: 'absolute',
            width: 'calc(100% - 30px)',
            height: 1,
            bottom: 0,
            background: '#E6E6E6',
            transform: 'scaleY(0.3)'
        }
    }
})

export const HomeItemLeftBgImage = style({
    width: '100%',
    height: COVERHEIGHT,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 6,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
})

export const StudyTotalNum = style({
    width: '100%',
    height: 22,
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    position: 'relative',
    background: '#F4F4F4',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    fontSize: 12,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '12px',
    $nest: {
        '& img': {
            width: 10,
            marginRight: 5
        }
    }
})

export const StudyTotalNumDiv = style({
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    marginLeft: 1
})

export const HomeItemRight = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    ...csstips.vertical,
    marginLeft: 10,
    width: `calc(100% - ${RIGHTDISTANCE}px)`
})

export const HomeItemRightTitle = style({
    fontSize: 16,
    fontWeight: 500,
    color: 'rgba(51,51,51,1)',
    lineHeight: '22px',
    marginTop: -3
})

export const HomeItemRightFreeLecture = style({
    fontWeight: 500
})

export const HomeItemRightBotton = style({
    ...csstips.flexRoot,
    ...csstips.end,
    lineHeight: '10px',
    overflow: 'visible',
    fontSize: 12,
    $nest: {
        '& span': {
            fontSize: 12,
            color: '#FF3F3C'
        },
        '& p': {
            fontSize: 14,
            color: '#FF3F3C',
            fontWeight: 500
        },
        '& del': {
            fontWeight: 400,
            fontSize: 10,
            color: '#999999'
        }
    }
})

export const HomeItemRightBottonRight = style({
    ...csstips.flexRoot
})

export const HomeItemRightBottonRightLimit = style({
    fontSize: 16
})

export const HomeItemLeftBottom = style({
    ...csstips.flexRoot,
    ...csstips.end,
    ...csstips.betweenJustified,
    ...csstips.center,
    marginBottom: 5
})

export const couponTagSm = style({
    padding: '4px 4px',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    color: '#fff',
    backgroundColor: '#FF3F3C',
    fontSize: 10,
    right: 0,
    bottom: 15,
    borderRadius: 3
})

export const couponTagSmText = style({
    fontSize: 12,
    transform: 'scale(1)',
    fontWeight: 600
})

export const youXuanType = style({
    top: 2,
    position: 'relative',
    marginRight: 4,
    height: 16,
    width: 35,
    display: 'inline-block'
})

export const couponTagBig = style({
    background: '#ff3f3c',
    opacity: 0.9,
    position: 'absolute',
    width: 70,
    height: 70,
    transform: 'rotate(45deg)',
    top: -35,
    left: -35
})

export const couponTagBigText = style({
    position: 'absolute',
    color: '#fff',
    fontSize: 12,
    top: 5,
    left: 5,
    transform: 'scale(1)',
    fontWeight: 600
})

export const HomeItemLeft = style({
    width: RIGHTDISTANCE,
    height: 89,
    position: 'relative',
    overflow: 'hidden',
    background: '#f4f4f4',
    borderRadius: 4
})

export const LiveStatusImg = style({
    width: 19,
    height: 12,
    marginRight: 5
})

export const isLivingText = style({
    fontSize: 12,
    color: '#999999',
    letterSpacing: 0,
    textAlign: 'justify',
    lineHeight: '12px'
})

export const HomeItemBigBgImage = style({
    padding: '15px 15px 5px 15px',
    $nest: {
        img: {
            borderRadius: 6
        },
        source: {
            borderRadius: 6
        }
    }
})

export const BottomTitleWrap = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    paddingLeft: 15,
    paddingRight: 15
})

export const title = style({
    width: 'calc(100% - 100px)',
    fontSize: 16,
    fontWeight: 500,
    color: 'rgba(51,51,51,1)',
    lineHeight: '22px',
    marginTop: 7
})

export const rightWrap = style({

})

export const popular = style({
    ...csstips.flexRoot,
    ...csstips.center,
    marginTop: 5,
    position: 'absolute',
    right: 15,
    $nest: {
        img: {
            width: 10
        },
        span: {
            marginLeft: 3
        }
    },
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(153,153,153,1)',
    lineHeight: '16px'
})

export const NumImg = style({
    width: 81
})

export const HomeItemListItemSpecial = style({
    textDecoration: 'none'
})

export const FavouriteIndexOne = style({
    paddingBottom: 14,
    position: 'relative',
    $nest: {
        '&:active': {
            backgroundColor: '#f8f8f8'
        },
        '&:after': {
            background: '#f0f0f0',
            bottom: 0,
            content: `" "`,
            height: 1,
            position: 'absolute',
            width: 'calc(100% - 30px)',
            left: '50%',
            transform: 'translateX(-50%) scaleY(0.5)'
        }
    }
})

export const HomeItemLastItem = style({
    $nest: {
        '&::after': {
            content: `" "`,
            position: 'absolute',
            width: 'calc(100% - 30px)',
            height: 1,
            bottom: 0,
            background: '#E6E6E6',
            transform: 'scaleY(0.3)'
        }
    }
})

export const Normalpopular = style({
    ...csstips.flexRoot,
    ...csstips.center,
    $nest: {
        img: {
            width: 10
        },
        span: {
            marginLeft: 3
        }
    },
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(153,153,153,1)',
    lineHeight: '16px'
})

export const NoPicStle = style({
    width: 65,
    position: 'absolute',
    zIndex: 1,
    bottom: -1,
    right: 0
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeFavourableRoll/HomeFavourableRoll.style.ts